<template>
  <v-container fluid full-height grid-list-md>
    <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="onSave">
      <v-layout row wrap>
        <v-flex xs6>
          <div class="text-xs-left">
            <v-breadcrumbs :items="breadcrumbs" divider=">">
              <template slot="item" slot-scope="props">
                <router-link
                  :to="'/'+props.item.to"
                  :disabled="props.item.disabled"
                  v-bind:class="{ 'v-breadcrumbs__item v-breadcrumbs__item--disabled': props.item.disabled }"
                >{{props.item.text}}</router-link>
              </template>
            </v-breadcrumbs>
          </div>
        </v-flex>
        <v-flex xs6>
          <div class="text-xs-right">
            <v-btn outline color="primary" @click="goBack">
              Go Back
              <v-icon right>arrow_back</v-icon>
            </v-btn>
          </div>
        </v-flex>
        <v-flex xs6 offset-sm3>
          <v-card>
            <v-layout row wrap class="pa-3">
              <v-flex sm12 v-if="responseError">
                <span class="red--text">{{responseError}}</span>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="cardNo"
                  label="Card No"
                  v-model="card.cardNo"
                  type="text"
                  :rules="rules.cardNoRules"
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <v-autocomplete
                  v-model="card.shopId"
                  :items="shopList"
                  color="blue-grey lighten-2"
                  label="Choose Shop..."
                  item-text="name"
                  item-value="id"
                  menu-props="auto"
                  :rules="rules.shopRules"
                ></v-autocomplete>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="description"
                  label="Card Description"
                  v-model="card.description"
                  type="text"
                  :rules="rules.descriptionRules"
                ></v-text-field>
              </v-flex>
              <v-flex sm12 v-if="card.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Created Date"
                    type="text"
                    prepend-icon="event"
                    v-model="createdDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="createdDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm12 v-if="card.id">
                <v-text-field
                  name="createdBy"
                  label="Created By"
                  v-model="card.createdBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm12 v-if="card.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Updated Date"
                    type="text"
                    prepend-icon="event"
                    v-model="updatedDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="updatedDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm12 v-if="card.id">
                <v-text-field
                  name="updateBy"
                  label="Updated By"
                  v-model="card.updatedBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm6 v-if="card.id">
                <v-switch
                  :label="`Status is ${statusFlag?'Active': 'Inactive'}`"
                  :value="statusFlag"
                  v-model="statusFlag"
                ></v-switch>
              </v-flex>
              <v-flex sm12>
                <div class="text-xs-center">
                  <v-btn color="error" @click="clear">
                    Reset
                    <v-icon right>clear</v-icon>
                  </v-btn>
                  <v-btn color="primary" :loading="saveLoading" :disabled="!valid" type="submit">
                    Save
                    <v-icon right>save</v-icon>
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-form>
  </v-container>
</template>

<script>
import { cardService } from "../../services/card-service";
import { Card } from "../../models/model";
import VSwitch from "vuetify/lib/components/VSwitch/VSwitch";
import { CardFormRules } from "../../helpers/validation-rules";
import { commonService } from "../../services/common-service";
import { shopService } from "../../services/shop-service";
export default {
  name: "CardDetail",
  components: { VSwitch },
  data: () => ({
    valid: true,
    breadcrumbs: [
      {
        text: "Card",
        disabled: false,
        to: "cards"
      },
      {
        text: "Card Detail",
        disabled: true
      }
    ],
    updatedDate: "",
    createdDate: "",
    card: new Card(),
    oldCard: new Card(),
    statusFlag: true,
    saveLoading: false,
    responseError: "",
    rules: new CardFormRules(),
    shopList: []
  }),
  created() {
    const id = this.$route.params.id;
    if (id == "new") {
      // new card
    } else {
      this.getCardDetail(id);
    }
    this.getShopList();
  },
  methods: {
    onSave() {
      if (this.$refs.form.validate()) {
        this.saveLoading = true;
        this.card.status = this.statusFlag ? "ACTIVE" : "INACTIVE";

        cardService
          .saveCard(this.card)
          .then(res => {
            console.log(res);
            this.goBack();
          })
          .catch(err => {
            console.log(err);
            if (err.response.data) {
              this.responseError = err.response.data.message;
            }
            this.saveLoading = false;
          });
      }
    },
    getCardDetail(id) {
      cardService
        .getCardDetail(id)
        .then(res => {
          this.card = res.data;
          this.createdDate = commonService.formatDate(
            new Date(this.card.createdDateInMilliSeconds)
              .toISOString()
              .substr(0, 10),
            "YYYY-MM-DD"
          );
          this.updatedDate = commonService.formatDate(
            new Date(this.card.updatedDateInMilliSeconds)
              .toISOString()
              .substr(0, 10),
            "YYYY-MM-DD"
          );

          this.oldCard = Object.assign({}, res.data);
          this.statusFlag = this.card.status == "ACTIVE" ? true : false;
        })
        .catch(err => {
          console.log(err);
        });
    },
    getShopList() {
      shopService
        .getAllShop()
        .then(res => {
          this.shopList = res.data;
        })
        .catch(err => {
          console.log(err);
        });
    },
    clear() {
      this.$refs.form.resetValidation();
      if (!this.card.id) {
        this.card = new Card();
        this.statusFlag = true;
      } else {
        this.card = Object.assign({}, this.oldCard);
        this.statusFlag = this.card.status == "ACTIVE" ? true : false;
      }
    },
    goBack() {
      this.$router.push("/cards");
    }
  }
};
</script>

